import {
  Description,
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';
import { FC, ReactNode } from 'react';
import CloseIcon from '@/assets/close.svg';
import { Button } from '@/components/ui/button';
import { DrawerLoader } from './drawer-loader';

export type DrawerProps = {
  children: ReactNode;
  loading?: boolean;
  open: boolean;
  subtitle?: string;
  title: string;
  setOpen: (open: boolean) => void;
};

export const Drawer: FC<DrawerProps> = ({
  children,
  loading,
  open,
  subtitle,
  title,
  setOpen,
}) => (
  <Dialog className="relative z-10" onClose={setOpen} open={open}>
    <DialogBackdrop
      transition
      className="drawer-dialog-backdrop fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
    />

    <div className="fixed inset-0 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
          <DialogPanel
            transition
            className="pointer-events-auto relative w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
          >
            <div className="flex h-full flex-col bg-white shadow-xl">
              <div className="flex flex-col gap-1.5 bg-secondary p-6 text-white">
                <div className="flex flex-row justify-between gap-2">
                  <DialogTitle className="text-base font-semibold">
                    {title}
                  </DialogTitle>
                  <Button
                    aria-label="close panel"
                    className="relative rounded-md bg-secondary text-white hover:bg-secondaryShade"
                    onClick={() => setOpen(false)}
                    type="button"
                    variant="unstyled"
                  >
                    <CloseIcon className="h-6 w-6" />
                  </Button>
                </div>
                {subtitle && (
                  <Description className="text-sm font-normal">
                    {subtitle}
                  </Description>
                )}
              </div>
              <div className="relative flex grow flex-col overflow-hidden">
                {children}
                {loading && <DrawerLoader />}
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </div>
  </Dialog>
);
